import { convertBytesToGB } from '@qmu/common/util/general';

export const isExceedMaxFileSize = (fileSizeInBytes: number, maxSupportedFileSize: number) => convertBytesToGB(fileSizeInBytes) >= maxSupportedFileSize;
